export default __webpack_public_path__ + "static/media/americanexpress.491ddff9.svg";